
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { DashboardFilterComponent } from './dashboard-filter/dashboard-filter.component';
import { DashboardContentComponent } from './dashboard-content/dashboard-content.component';
import { DueDatesWidgetComponent } from './due-dates-widget/due-dates-widget.component';
import { TaxNewsWidgetComponent } from './tax-news-widget/tax-news-widget.component';
import { LawChangesWidgetComponent } from './law-changes-widget/law-changes-widget.component';
import { HomePageCountryDialogComponent } from "@features/dashboard/home-page-country-dialog/home-page-country-dialog.component";
import { PowerSearchDashboardV2Component } from './power-search-dashboard-v2/power-search-dashboard-v2.component';
import { DashboardHomeCardsComponent } from './dashboard-home-cards/dashboard-home-cards.component';
import { ProfileTimeZoneBannerComponent } from './components/profile-time-zone-banner/profile-time-zone-banner.component';
// @dynamic
export class DashboardDynamicComponentHelper {
  public static components: any;
  public static init() {
    if (DashboardDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    components['DashboardFilterComponent'] = DashboardFilterComponent;
    components['DashboardContentComponent'] = DashboardContentComponent;
    components['DueDatesWidgetComponent'] = DueDatesWidgetComponent;
    components['TaxNewsWidgetComponent'] = TaxNewsWidgetComponent;
    components['LawChangesWidgetComponent'] = LawChangesWidgetComponent;
    components['HomePageCountryDialogComponent'] = HomePageCountryDialogComponent;
    components['PowerSearchDashboardV2Component'] = PowerSearchDashboardV2Component;
    components['DashboardHomeCardsComponent'] = DashboardHomeCardsComponent;
    // ITP-E-335-02: the BannerComponent every Home link names.
    components['ProfileTimeZoneBannerComponent'] = ProfileTimeZoneBannerComponent;

    DashboardDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static getComponentArray(): any[] {
    DashboardDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(DashboardDynamicComponentHelper.components).forEach(key => {
      componentArray.push(DashboardDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
